import { useEffect, useMemo, useState } from "react";
import { canViewHref } from "@/lib/acl";
import { useCurrentUser } from "@/lib/auth";

export interface SettingsAcl {
  loading: boolean;
  canAuftraege: boolean;
  canBestellungen: boolean;
  canSessions: boolean;
}

export function useSettingsAcl(): SettingsAcl {
  const { user } = useCurrentUser();
  const groups = useMemo(() => (user?.groups as string[] | undefined) ?? [], [user]);
  const [acl, setAcl] = useState<Omit<SettingsAcl, "loading">>({
    canAuftraege: false,
    canBestellungen: false,
    canSessions: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!user) {
      setLoading(false);
      return;
    }
    (async () => {
      const [canAuftraege, canBestellungen, canSessions] = await Promise.all([
        canViewHref("/auftraege", groups),
        canViewHref("/bestellungen", groups),
        canViewHref("/admin/einstellungen", groups),
      ]);
      if (!cancelled) {
        setAcl({ canAuftraege, canBestellungen, canSessions });
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user, groups]);

  return { ...acl, loading };
}
